import { apiClient } from "@api/client";
import { request } from "@api/request";
import type { components } from "@api/schema";

interface ClinicInfo {
  uuid: string;
  name: string;
  subdomain: string;
  email: string;
  timezone: string;
  address: string | null;
  // Presigned GET.
  logoUrl: string | null;
}

const toClinicInfo = (c: components["schemas"]["ClinicOut"]): ClinicInfo => ({
  uuid: c.uuid,
  name: c.name,
  subdomain: c.subdomain,
  email: c.email,
  timezone: c.timezone,
  address: c.address ?? null,
  logoUrl: c.logo_url ?? null,
});

export const clinicClient = {
  get: () =>
    request(() => apiClient.GET("/auth/clinic", {})).then(toClinicInfo),
};
